module.exports = "/_next/static/images/WebSecondProcess-48a684b0f45094f0da1f28bcf3d21949.png";